﻿import { ProductInteraction } from './ProductInteraction.js';

export const EditScope = {
  product: 'product'
};

export const ComponentType = {
  mainFinish: {
    id: 'mainFinish',
    useEditScope: false,
    defaultEditScope: 'product',
    getValue: (apiProduct) => apiProduct.f,
    getAllUsedValues: (product) => product.getAllPrimaryFinishes(),
    handleDrawingClick: (interaction, event) => interaction.handleMainFinishClick(event),
    showGalleryFilterButton: false,
  },
  metalFinish: {
    id: 'metalFinish',
    useEditScope: false,
    defaultEditScope: 'product',
    getValue: (apiProduct) => apiProduct.f,
    getAllUsedValues: (product) => product.getAllSecondaryFinishes(),
    handleDrawingClick: (interaction, event) => interaction.handleMetalFinishClick(event),
    showGalleryFilterButton: false,
  },
};

export class InteriorInteraction extends ProductInteraction {
  constructor() {
    super();
    this._editScope = EditScope.product;
    this._componentType = ComponentType.mainFinish;
    /* We need to create a wrapper object for the removeEventListener call to actually remove the
     * listener. This happens inside the drawing engine's toggleDisplayObjectInteractive method. */
    this.mainFinishClickHandler = { handler: event => this.handleMainFinishClick(event) };
    this.metalFinishClickHandler = { handler: event => this.handleMetalFinishClick(event) };
  }

  activateInteraction(on) {
    super.activateInteraction(on);
    if (this.product) {
      switch (this.componentType) {
        case ComponentType.mainFinish:
          if (this.editScope === EditScope.product) {
            /* Passing an arrow function to the method may prevent the toggleInteractive method from
             * successfully unregistering the event. Instead we use a wrapper object. */
            //this.toggleInteractive(this.product.displayObject, on, (event) => this.handleMainFinishClick(event));
            this.toggleInteractive(this.product.displayObject, on, this.mainFinishClickHandler.handler);
          } else {
            this.unsupportedTypeAndScope();
          }
          break;

        case ComponentType.metalFinish:
          if (this.editScope === EditScope.product) {
            /* Passing an arrow function to the method may prevent the toggleInteractive method from
             * successfully unregistering the event. Instead we use a wrapper object. */
            //this.toggleInteractive(this.product.displayObject, on, (event) => this.handleMetalFinishClick(event));
            this.toggleInteractive(this.product.displayObject, on, this.metalFinishClickHandler.handler);
          } else {
            this.unsupportedTypeAndScope();
          }
          break;

        default:
          this.unsupportedTypeAndScope();
          break;
      }
    }
  }

  doOnMainFinishChanged(product, { oldFinish, oldDisplayObject }) {
    if (this.onMainFinishChanged) {
      this.onMainFinishChanged(this, oldFinish, product);
    }
  }

  doOnMetalFinishChanged(product, { oldFinish, oldDisplayObject }) {
    if (this.onMetalFinishChanged) {
      this.onMetalFinishChanged(this, oldFinish, product);
    }
  }

  handleMainFinishClick(event) {
    if (this.selectedValue) {
      const product = event.currentTarget.dataComponent;
      let wasChanged = false;
      product.replaceFinishesRecursively(this.selectedValue, (product, args) => {
        this.doOnMainFinishChanged(product, args);
        wasChanged = true;
      });
      if (wasChanged) {
        /* We only need to make this call if the replaced display object is interactive. Since we currently
         * only have click handlers on the root module (e.g. flexi-section or organizer), and we
         * don't replace their display object (we only replace the leaf display objects, e.g. shelves),
         * we have commented out this next line: */
        //this.refreshInteractive(oldDisplayObject, product.displayObject, this.mainFinishClickHandler.handler);
        this.doOnProductChanged(product);
      }
      this.doOnInteraction(event);
    }
  }

  handleMetalFinishClick(event) {
    if (this.selectedValue) {
      const product = event.currentTarget.dataComponent;
      let wasChanged = false;
      product.replaceSecondaryFinishesRecursively(this.selectedValue, (product, args) => {
        this.doOnMetalFinishChanged(product, args);
        wasChanged = true;
      });
      if (wasChanged) {
      /* We only need to make this call if the replaced display object is interactive. Since we currently
       * only have click handlers on the root module (e.g. flexi-section or organizer), and we
       * don't replace their display object (we only replace the leaf display objects, e.g. shelves),
       * we have commented out this next line: */
        //this.refreshInteractive(oldDisplayObject, product.displayObject, this.metalFinishClickHandler.handler);
        this.doOnProductChanged(product);
      }
      this.doOnInteraction(event);
    }
  }
}
